import { render, staticRenderFns } from "./aiFrame.vue?vue&type=template&id=7f86845c"
import script from "./aiFrame.vue?vue&type=script&lang=js"
export * from "./aiFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports